import { reactive } from 'vue'

// Global overlays of the shell, opened from anywhere (production: JX_AUTH.showLogin, openContactQr and the
// first-visit notice). Each overlay mounts once in App.vue.
export type AuthMode = 'login' | 'register' | 'reset'
export type AuthReason = 'success' | 'cancel'

export const overlays = reactive({
  auth: null as null | { mode: AuthMode; method: 'code' | 'password'; message: string; onClose?: (reason: AuthReason) => void },
  contact: false,
})

export function openAuth(mode: AuthMode = 'login', options: { method?: 'code' | 'password'; message?: string; onClose?: (reason: AuthReason) => void } = {}) {
  if (overlays.auth) return
  overlays.auth = { mode, method: options.method ?? 'code', message: options.message ?? '', onClose: options.onClose }
}

export function closeAuth(reason: AuthReason) {
  const current = overlays.auth
  overlays.auth = null
  current?.onClose?.(reason)
}

export const openContact = () => { overlays.contact = true }
export const closeContact = () => { overlays.contact = false }
